module.exports = __webpack_public_path__ + "img/transfiere.d98db04e.svg";